module.exports = __webpack_public_path__ + "img/title1.81080766.png";